import { ref, type Ref } from 'vue';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'autospy.theme';
/* Must match --bg in styles.css per theme (browser chrome / PWA titlebar). */
const THEME_COLOR: Record<Theme, string> = { dark: '#232227', light: '#f3f1ec' };

function readStored(): Theme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

const theme: Ref<Theme> = ref(readStored());

function apply(t: Theme): void {
  document.documentElement.dataset.theme = t;
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', THEME_COLOR[t]);
}

/** Apply the persisted theme on boot (dark is the default). */
export function initTheme(): void {
  apply(theme.value);
}

export function useTheme(): { theme: Ref<Theme>; toggleTheme: () => void } {
  return { theme, toggleTheme };
}

function toggleTheme(): void {
  theme.value = theme.value === 'dark' ? 'light' : 'dark';
  apply(theme.value);
  try {
    localStorage.setItem(STORAGE_KEY, theme.value);
  } catch {
    /* private mode etc. — theme just won't persist */
  }
}
